import { reactive, ref, h } from 'vue'
import { MessageBox, Message } from '@qs/ui'
import {
  enableStaff,
  isAuditor,
  setPassword,
  getSensitiveStaffList,
} from '@/api/domain/organize'
import RoleState from './components/roleState'


export const tableFakeHook = (getOperateList, beforeFetch, afterFetch, detailDrawerRef) => {
  const tableData = ref([])
  const multipleSelection = ref([])
  const columns = ref([
    {
      name: 'selection',
      columnProps: {
        prop: 'selection',
        type: 'selection',
        width: 40,
      },
    },
    {
      name: 'id',
      columnProps: {
        label: '员工ID',
        prop: 'id',
      },
      render: ({ row }) => {
        return <span class="a-hover-link" onClick={() => detailDrawerRef(row)}>{row.id}</span>
      },
    },
    {
      name: 'userName',
      columnProps: {
        label: '姓名',
        prop: 'userName',
      },
    },
    {
      name: 'userAccount',
      columnProps: {
        label: '账号',
        prop: 'userAccount',
      },
    },
    {
      name: 'userMobile',
      columnProps: {
        label: '手机号',
        prop: 'userMobile',
      },
    },
    {
      name: 'roleList',
      columnProps: {
        label: '角色权限',
        prop: 'roleList',
        width: 140,
      },
      render: ({ row }) => {
        if (row.roleList?.length > 0) {
          return <RoleState roleList={row.roleList} />
        }
        return '- -'
      },
    },
    {
      name: 'deptName',
      columnProps: {
        label: '所属部门',
        prop: 'deptName',
      },
    },
    {
      name: 'state',
      columnProps: {
        label: '账号状态',
        prop: 'state',
      },
      tagProps: ({ row }) => {
        return { type: row.state ? 'success' : 'error' }
      },
      getTagText: ({ row }) => {
        return row.state ? '启用' : '禁用'
      },
      type: 'tag',
    },
    {
      name: 'operate',
      columnProps: {
        label: '操作',
        width: 180,
        fixed: 'right',
      },
      type: 'operate',
      getOperateList,
    },
  ])
  const pagination = reactive({
    pageSize: 10,
    pageNum: 1,
    total: 0,
    pagerCount: 5,
  })

  // 获取table 数据
  const getEmployeeList = async () => {
    const params = await beforeFetch()
    if (!params) return
    tableData.value = []
    const { pageSize, pageNum } = pagination
    getSensitiveStaffList({ ...params, pageSize, pageNum }).then(({ code, data }) => {
      if (code !== 1) return
      tableData.value = data?.items || []
      pagination.total = data?.totalNum || 0
    }).finally(() => {
      afterFetch && afterFetch()
    })
  }
  const handleSelectionChange = (rows) => {
    multipleSelection.value = rows
  }
  const pageChange = (payload) => {
    pagination.pageNum = payload.pagination.pageNum
    pagination.pageSize = payload.pagination.pageSize
    getEmployeeList()
  }

  return {
    tableData,
    multipleSelection,
    columns,
    handleSelectionChange,
    pagination,
    pageChange,
    getEmployeeList,
  }
}


export const handleResetPassword = (id) => {
  MessageBox.prompt('新密码', '密码重置', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    inputPattern: /^[0-9a-zA-Z]{6,18}$/,
    inputErrorMessage: '请输入6-18位的数字或字母',
  }).then(async ({ value }) => {
    const { code, data } = await setPassword({
      id,
      password: value,
    })
    if (code === 1 && data) {
      Message.success('密码重置成功')
    }
  })
}


// 启用禁用员工状态
const enable = (state, userName, id, callback) => {
  const txt = state ? '启用' : '禁用'
  MessageBox.confirm(`是否确定${txt}【${userName}】?`, `${txt}提示`, {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(async () => {
    const { code } = await enableStaff({
      id,
      state,
    })
    if (code !== 1) return
    Message.success(`${txt}${userName}成功`)
    callback && callback()
  })
}
// 启用禁用员工 逻辑
export const handleStateStaff = async (row, callback) => {
  const { id, state, userName, userMobile, tenantId } = row
  // 启用
  if (!state) {
    enable(1, userName, id, callback)
    return
  }

  // 禁用判断
  const { code, data } = await isAuditor({
    userId: id,
    tel: userMobile,
    tenantId,
  })

  if (code === 1 && data) {
    MessageBox.alert(
      '该账号为审批人员，请及时调整审批流配置后再进行禁用操作',
      '禁用提示',
      {
        confirmButtonText: '确定',
      },
    )
    return
  }
  // 禁用
  enable(0, userName, id, callback)
}

export const SCENE_MAPPING = {
  CUSTMER: 1,
  CHOOSE: 2,
}

